require('./assets/css/style.css')

import Vue from 'vue'
import App from './App.vue'
import VueGAPI from "vue-gapi";
import VueRouter from 'vue-router'
import Assumptions from './components/Assumptions.vue'
import Inputs from './components/Inputs.vue'
import VTooltip from 'v-tooltip'
import Vuelidate from 'vuelidate'

Vue.use(Vuelidate)
Vue.use(VTooltip)
Vue.use(VueRouter)

import store from './store'

const routes = [
  {
    path: '/',
    component: Inputs,
    name: 'home'
  },
  {
    path: '/assumptions',
    component: Assumptions,
    name: 'assumptions'
  },
]

const router = new VueRouter({
  scrollBehavior (to, from, savedPosition) {
    if (to.name == 'assumptions') {
      return {selector: '#assumptions-form'}
    } else if (to.name == 'home') {
      return {selector: '#input-form'}
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes
})

var GOOGLE_CLIENT_ID = process.env.VUE_APP_GCLIENT_ID;
var GOOGLE_API_KEY = process.env.VUE_APP_GAPI_KEY;
var DISCOVERY_DOCS = ["https://sheets.googleapis.com/$discovery/rest?version=v4"];
var SCOPES = "https://www.googleapis.com/auth/spreadsheets.readonly";

const apiConfig = {
  apiKey: GOOGLE_API_KEY,
  clientId: GOOGLE_CLIENT_ID,
  discoveryDocs: DISCOVERY_DOCS,
  scope: SCOPES
};

Vue.use(VueGAPI, apiConfig);

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
